export const LOKI_LINKEDINPREBIND_UI_FLIGHTNAME = 'displaylinkedindataprebind';
